module.exports = __webpack_public_path__ + "media/images/common/ico-login-611294ebdcb2bfa9cf5383a670f17145.svg";